var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KTCard',[_c('DocumentInput',{attrs:{"name":"brief","file-data":_vm.brief},on:{"change":_vm.changeBrief}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }